import {Box} from "@mui/system";
import {Chart, Axis, Tooltip, Interval} from "bizcharts";
import {useState} from "react";

const HistogramChart = (props) => {
  const data = [{'label': '0', 'value': 50524}, {'label': '1', 'value': 13874}, {'label': '2', 'value': 7294}, {'label': '3', 'value': 5232}, {'label': '4', 'value': 3667}, {'label': '5', 'value': 2302}, {'label': '6', 'value': 1419}, {'label': '7', 'value': 848}, {'label': '8', 'value': 464}, {'label': '9', 'value': 291}, {'label': '10', 'value': 184}, {'label': '11', 'value': 111}, {'label': '12', 'value': 54}, {'label': '13', 'value': 40}, {'label': '14', 'value': 24}, {'label': '15', 'value': 28}, {'label': '16', 'value': 10}, {'label': '17', 'value': 14}, {'label': '18', 'value': 12}, {'label': '19', 'value': 9}, {'label': '20', 'value': 11}, {'label': '21', 'value': 4}, {'label': '22', 'value': 4}, {'label': '23', 'value': 3}, {'label': '24', 'value': 4}, {'label': '25', 'value': 3}, {'label': '26', 'value': 5}, {'label': '27', 'value': 1}, {'label': '28', 'value': 2}, {'label': '29', 'value': 4}, {'label': '30', 'value': 1}, {'label': '31', 'value': 4}, {'label': '32', 'value': 1}, {'label': '36', 'value': 1}];
  const scale = {
    label: {
      tickInterval: 1,
    },
    value: {formatter: (val) => " " + val.toLocaleString()},
  };
  const [canvas, setCanvas] = useState(undefined);

  return (
    <Box>
      <Box>
        <Chart
          height={ 300 }
          autoFit
          scale={ scale }
          data={ data }
          binWidth={ 1 }
          interactions={ ["active-region"] }
          onGetG2Instance={ (chartInstance) => {
            setTimeout(() => {
              setCanvas(chartInstance.canvas);
            }, 1000);
          } }
        >
          { " " }
          <Axis
            name="value"
            label={ {
              formatter: (val) => {
                return val.toLocaleString();
              },
              style: {
                fontFamily: "Roboto Condensed, sans-serif",
              },
            } }
          />{ " " }
          <Axis
            name="label"
            label={ {
              style: {
                fontFamily: "Roboto Condensed, sans-serif",
              },
            } }
          />{ " " }
          <Interval
            position="label*value"
            size={ 16 }
            style={ {
              stroke: "#F9B112",
              fill: "#F9B112",
              fillOpacity: 1,
              lineWidth: 1,
            } }
          />{ " " }
          <Tooltip shared>
            { (title, items) => {
              const filtered = data.filter((d) => d["label"] === title);
              return (
                <div
                  id="#tooltipWrap"
                  style={ {
                    padding: "5px 10px 10px 5px",
                    width: "auto",
                    color: "#22294D",
                    fontFamily: "Roboto Condensed",
                    opacity: "1",
                  } }
                >
                  <div
                    className="g2-tooltip-title"
                    style={ {
                      fontSize: "medium",
                      paddingBottom: "0",
                      fontWeight: "bold",
                    } }
                  >
                    { filtered[0]["label"] } Results
                  </div>
                  <ul className="g2-tooltip-list">
                    <li style={ {padding: "2px 0"} } data-index="0">
                      { filtered[0]["value"].toLocaleString() } samples
                    </li>
                  </ul>
                </div>
              );
            } }
          </Tooltip>
        </Chart>
      </Box>
    </Box>
  );
};

export default HistogramChart;
